module.exports = __webpack_public_path__ + "static/media/Piercing-mascintimate-princealbertinvert.75e50130.png";